<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title>UPDATE PROJECT CLIENT</v-card-title>
      <v-container>
        <label>Clients</label>
        <v-autocomplete
          outlined
          item-color="green"
          label="choose client"
          v-model="clientData"
          :items="projectClientList"
          item-text="client_name"
          item-value="id"
        ></v-autocomplete>
        <v-card-actions>
          <v-btn rounded color="primary" @click="updateClient()">Update</v-btn>
          <v-btn rounded color="secondary" @click="clearClient">Cancel</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import DEFAULT_CONSTANTS from "@/Utilites/constants";
export default {
  name: "ProjectClientEdit",
  props: ["editClient", "projectClientList"],
  data() {
    return {
      clientData: "",
    };
  },
  computed: {
    ...mapGetters(["getProjectClient"]),
    show: {
      get() {
        return this.editClient;
      },
      set(show) {
        this.$emit("update-edit-client-modal", show);
      },
    },
  },
  methods: {
    ...mapActions([
      "UpdateProjectClient",
      "showLoadingProcess",
      "closeLoading",
      "showSnackBar",
      "closeSnackBar",
    ]),
    async updateClient() {
      await this.showLoadingProcess();
      try {
        const data = {
          id: this.getProjectClient[0].id,
          client_id: this.clientData,
        };
        await this.UpdateProjectClient(data);
        await this.closeLoading();
        await this.showSnackBar({
          text: "Client has been updated",
          color: DEFAULT_CONSTANTS.success,
        });
        this.clearClient();
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      } catch (err) {
        console.log(err);
        await this.closeLoading();
        this.clearClient();
        await this.showSnackBar({
          text: JSON.stringify(err),
          color: DEFAULT_CONSTANTS.error,
        });
        setTimeout(async () => {
          await this.closeSnackBar();
        }, DEFAULT_CONSTANTS.timeout);
      }
    },

    clearClient() {
      this.show = false;
      this.clientData = "";
    },
  },
};
</script>

<style scoped></style>
